import React from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { mailchimpIntegrationUrl } from '../../../constants/integrationConstants';
import { CustomButton } from '../../../components/buttons/customButton';
import SecondaryButton from '../../../components/buttons/secondaryButton';
import { Colors } from '../../../constants/constants';
import useGetOrganizationSettings from '../../../apiHooks/queries/useGetOrganizations';
import { ORGANIZATION_SETTINGS } from '../../../constants/pageIdentifiers';
import LoadingSpinner from '../../../components/loadingSpinner/loadingSpinner';

const MailchimpPanel = () => {
  const { t } = useTranslation();
  const {
    data: organizationSettings,
    isFetching,
  } = useGetOrganizationSettings(ORGANIZATION_SETTINGS);

  const mailChimpServerPrefix = organizationSettings?.data?.data?.mailchimpServerPrefix;
  const hasToken = organizationSettings?.data?.data?.isMailchimpActive;

  if (isFetching) {
    return (
      <div className="flex items-center justify-center ">
        <LoadingSpinner color="primary" size={50} />
      </div>
    );
  }

  if (hasToken) {
    return (
      <div>
        <div className="flex items-center gap-[10px]  ">
          <div className="flex flex-row items-center gap-[14px]
          rounded-lg border-[1px] border-[#EAEAEA] px-[20px] py-[10px]"
          >
            <p className="whitespace-nowrap text-center text-xs font-[500] text-primary">
              {t('accountStatus')}
            </p>
            <SecondaryButton
              style={{
                border: `1px solid ${hasToken ? Colors.green : Colors.red}`,
                color: hasToken ? Colors.green : Colors.red,
                height: '40px',
                fontSize: 14,
              }}
            >
              {hasToken ? t('Active') : t('notActive')}
            </SecondaryButton>
          </div>
          <div className="flex w-[86%] justify-between rounded-lg border-[1px] border-[#EAEAEA] bg-white px-5 py-2
          align-middle"
          >
            <span className="mt-1 items-center ">
              <p className="text-[12px] font-[800] text-primary ">
                {t('disconnectIntegration')}
              </p>
              <p className="font-[400]] text-[12px] text-primary">
                {t('removeIntegration')}
              </p>
            </span>
            <CustomButton
              className="h-full px-6 py-3"
              onClick={() => alert('Disconnected')}
            >
              {t('disconnect')}
            </CustomButton>
          </div>
        </div>
        <div className="mt-2.5 rounded-lg border-[1px] bg-white">
          <div className=" m-2.5 rounded-lg bg-gray-200  pt-4">
            <label className="font-me mb-2 block pl-3.5 text-[#0C485E]">Mailchimp Server Prefix</label>
            <div className="flex w-full items-center justify-between rounded-b-lg border-[1px] bg-white p-3 text-[#0C485E] ">
              <p className=" align-middle text-sm">
                {mailChimpServerPrefix && mailChimpServerPrefix.slice(0, 50)}
              </p>
              <CopyToClipboard text={mailChimpServerPrefix || ''}>
                <Tooltip title={t('copyToClipboard')} arrow placement="top">
                  <Button
                    style={{
                      minWidth: '40px',
                      height: '40px',
                      color: Colors.primary,
                      justifySelf: 'center',
                      border: '1px solid #EAEAEA ',
                      borderRadius: '8px',
                      padding: '6px',
                    }}
                  >
                    <ContentCopyIcon style={{
                      width: '18px',
                      height: '18px',
                    }}
                    />
                  </Button>
                </Tooltip>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (

    <div className="flex justify-between gap-5 rounded-xl border p-4">
      <div className="flex flex-col gap-2 text-primary">
        <span className="text-sm font-semibold">Connect to Mailchimp</span>
        <p className="text-sm font-normal">
          Here you can link your Mailchimp account with our platform for more efficient tracking.
        </p>
      </div>
      <CustomButton
        loading
        type="button"
        onClick={() => window.location.replace(mailchimpIntegrationUrl)}
      >
        {t('connectToMailchimp')}
      </CustomButton>
    </div>
  );
};
export default MailchimpPanel;
